import { createFileRoute } from "@tanstack/react-router";
import { FilesPage } from "../features/files/files-page";
import { validateFilesSearch } from "../features/files/search";

export const Route = createFileRoute("/_app/files")({
  validateSearch: validateFilesSearch,
  component: FilesPage,
});
